export default class PolyfillLoader {
    init(): Promise<any> {
        return Promise.all([
            this.initBabel(),
            this.initFetchPolyfill(),
            this.initPictureFill(),
            this.initScrollTo(),
            this.initElementClosest(),
            this.initElementRemove(),
            this.initCustomeEventPolyfill(),
            this.initNodelistForeachPolyfill()
        ]);
    }

    private initBabel(): Promise<any> {
        return new Polyfill('babel-polyfill', needArrayFrom).setup();
    }

    private initPictureFill(): Promise<any> {
        return new Polyfill('picture-fill', needPictureFill).setup();
    }

    private initFetchPolyfill(): Promise<any> {
        return new Polyfill('fetch-polyfill', needFetch).setup();
    }

    private initScrollTo(): Promise<any> {
        return new Polyfill('scrollTo-polyfill', needArrayFrom).setup();
    }

    private initElementClosest(): Promise<any> {
        return new Polyfill('element-closest', needElementClosest).setup();
    }

    private initElementRemove(): Promise<any> {
        return new Polyfill('element-remove', needElementRemove).setup();
    }

    private initCustomeEventPolyfill(): Promise<any> {
        return new Polyfill('events-polifyll', needCustomEvent).setup();
    }

    private initNodelistForeachPolyfill(): Promise<any> {
        return new Polyfill('nodelist-foreach-polyfill', needCustomEvent).setup();
    }
}

class Polyfill {
    constructor(private polyfillName: string, private isNecessery: () => boolean) { }

    setup(): Promise<any> {
        if (this.isNecessery()) {
            return this.loadModule();
        }
    }

    private loadModule(): Promise<any> {
        this.polyfillName;
        return import(/* webpackChunkName: "[request]" */'./polyfills/' + this.polyfillName)
            .catch(error => console.warn(`Polyfill [${this.polyfillName}] wasn't loaded:\n${error}`));
    }
}

const needPictureFill = () => {
    const strObj = '' + document.createElement('picture');
    const supportsPictureElement = strObj.indexOf('HTMLPictureElement') !== -1;

    return !supportsPictureElement;
}

const needArrayFrom = () => !Array.from;

const needElementClosest = () => !Element.prototype.closest;

const needElementRemove = () => !Element.prototype.remove;

const needFetch = () => !window.fetch;

const needCustomEvent = () => {
    try {
        new CustomEvent('someCustomEvent');
        return false;
    } catch (e) {
        return true;
    }
}
